module.exports = __webpack_public_path__ + "static/media/ic_undo.f77a4f91.svg";